<template>
  <div class="ui three cards">
    <div
      class="card"
      v-for="(mdle, index) in modules"
      v-bind:key="index"
      v-bind:class="{
        hidden:
          (hide_unused &&
            (!mdle.usr_module_suscriptions ||
              !mdle.usr_module_suscriptions.length)) ||
          mdle.setup.parent_modules,
        blue: mdle.usr_module_suscriptions.length > 0,
        red: mdle.usr_module_suscriptions.length == 0,
      }"
    >
      <div class="content">
        <img class="left floated mini ui image" :src="mdle.setup.image" />
        <div class="right floated buttons">
          <div
            class="ui icon basic mini button"
            :data-tooltip="$t('deactivate')"
            v-if="mdle.usr_module_suscriptions.length > 0"
            v-on:click="deactivate(mdle, index)"
          >
            <i class="red remove icon"></i>
          </div>
          <div
            class="ui icon basic mini button"
            :data-tooltip="$t('activate')"
            v-if="mdle.usr_module_suscriptions.length == 0"
            v-on:click="activate(mdle, index)"
          >
            <i class="green plus icon"></i>
          </div>
          <div
            class="ui icon basic mini button"
            :data-tooltip="$t('configure')"
            v-if="mdle.setup.configure_component"
            @click="configure(mdle, index)"
          >
            <i class="settings mark icon"></i>
          </div>
          <!-- <div
              class="ui icon help basic mini button"
              :data-tooltip="$t('help')"
              :data-content="(mdle.setup.description)"
            >
              <i class="blue question mark icon"></i>
            </div>-->
        </div>
        <div class="header">{{ $t(mdle.setup.name) }}</div>
        <!-- <div class="description">{{ $t(module.setup.description) }}</div> -->
        <div class="description">
          <!-- <h4
              class="ui dividing header"
              style="margin-top:10px"
              v-if="submodules(module).length"
            >{{ $t("submodules")}}</h4>-->
          <div
            class="ui divided selection list"
            style="margin-top:10px"
            v-if="submodules(mdle).length"
          >
            <div
              class="item"
              v-for="(sb, idx) in submodules(mdle)"
              :key="idx"
              v-bind:class="{
                hidden:
                  hide_unused &&
                  (!sb.usr_module_suscriptions ||
                    !sb.usr_module_suscriptions.length),
              }"
            >
              <!-- <i class="right triangle icon middle aligned icon"></i> -->
              <div class="content">
                <div class="right floated buttons">
                  <div
                    class="ui icon basic mini button"
                    v-bind:class="{
                      hidden: hide_unused && !sb.usr_module_suscriptions.length,
                    }"
                    :data-tooltip="$t('deactivate')"
                    v-if="sb.usr_module_suscriptions.length > 0"
                    v-on:click="deactivate(sb, index)"
                  >
                    <i class="red remove icon"></i>
                  </div>
                  <div
                    class="ui icon basic mini button"
                    :data-tooltip="$t('activate')"
                    v-if="sb.usr_module_suscriptions.length == 0"
                    v-on:click="activate(sb, index)"
                  >
                    <i class="green plus icon"></i>
                  </div>
                  <div
                    class="ui icon basic mini button"
                    :data-tooltip="$t('configure')"
                    v-if="sb.setup.configure_component"
                    @click="configure(sb, index)"
                  >
                    <i class="settings mark icon"></i>
                  </div>
                  <!-- <div
                      class="ui icon help basic mini button"
                      :data-tooltip="$t('help')"
                      :data-content="(sb.setup.description)"
                    >
                      <i class="blue question mark icon"></i>
                    </div>-->
                </div>
                <div class="header" style="fore-color:#eee">
                  {{ $t(sb.setup.name) }}
                </div>
                <!-- <div class="description">{{ $t(sb.setup.description) }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsModuleManagementCardsView",
  props: {
    modules: { type: Array },
    hide_unused: { type: Boolean },
  },
  data() {
    return {};
  },
  methods: {
    submodules(module) {
      let subm = this.modules.filter((m) => {
        return (
          m.setup &&
          m.setup.parent_modules &&
          m.setup.parent_modules.includes(module.setup.name)
        );
      });
      return subm;
    },
    deactivate(module) {
      this.$emit("deactivate", module);
    },
    activate(module) {
      this.$emit("activate", module);
    },
    configure(module) {
      this.$emit("configure", module);
    },
  },
};
</script>
